import { Billing } from "@/type/core/offices/offices.types";
import configuration from "@/utils/Config";
import { restUpdateHandler } from "@/utils/rest/RestClient";
import { createEffect } from "effector";

const baseUrl = configuration.backendBaseUrl;
const billingUrl = baseUrl + "/ws/fo/billing";

export const requestUpdateBilling = createEffect({
  handler: restUpdateHandler<Billing, void>(billingUrl),
});
